import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import PageNotFound from "./components/PageNotFound.vue";
import MileLogix from "./views/MileLogix.vue";
import MileLogixFT from "./views/MileLogixFT.vue";
import Registration from "./views/Registration.vue";
import store from "./store.js";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "login",
      component: Login
    },
    {
      path: "/milelogix",
      name: "milelogix",
      component: MileLogix,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/milelogix-for-teams",
      name: "milelogix-for-teams",
      component: MileLogixFT,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "*",
      component: PageNotFound
    },
    {
      path: "/register",
      name: "register",
      component: Registration
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next("/");
  } else {
    next();
  }
});

export default router;
